import { TableToolsBar } from '@/lib/v2/organisms';

import DeleteActionRecurringMessageDetailModal from './DeleteActionRecurringMessageDetailModal';

import { useActionBar } from '@/modules/AutomationModuleNew/hooks/useActionBar';
import { ICampaignActions } from '@/modules/CampaignsModule/interfaces/CampaignActions';

interface ActionBarRecurringMessagesDetailProps {
  totalRowSelected: number;
  dataSelected: ICampaignActions[];
  refetchData: () => void;
}

const ActionBarRecurringMessagesDetail = ({
  dataSelected,
  refetchData,
  totalRowSelected,
}: ActionBarRecurringMessagesDetailProps) => {
  const { actions, deleteModalIsOpen, toggleDeleteModal } = useActionBar({
    totalRowSelected,
    hideDuplicateButton: true,
    hideEditButton: true,
  });

  const actionsIds = dataSelected.map((RM) => RM.actionId);

  return (
    <div>
      <TableToolsBar>
        {actions
          .filter((element) => !element.hide)
          .map((element) => {
            const { label, icon, tooltip, onClick: handleOnClick, id } = element;
            return (
              <TableToolsBar.Button
                key={id}
                icon={icon}
                id={id}
                label={label}
                tooltip={tooltip}
                onClick={handleOnClick}
              />
            );
          })}
      </TableToolsBar>
      {deleteModalIsOpen && (
        <DeleteActionRecurringMessageDetailModal
          actionsIds={actionsIds}
          isOpen={deleteModalIsOpen}
          refetchData={refetchData}
          totalRowSelected={totalRowSelected}
          onClose={toggleDeleteModal}
        />
      )}
    </div>
  );
};

export default ActionBarRecurringMessagesDetail;
